// extracted by mini-css-extract-plugin
module.exports = {"main_container":"GroupFooter_main_container__Vse6J","footer_body":"GroupFooter_footer_body__dvvlg","bar":"GroupFooter_bar__m7Hx_"};